import React, { useState, useContext, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Card, Dropdown, Row, Col } from "react-bootstrap";
import ChartsContext from 'contexts/ChartsContext';

ChartJS.register(ArcElement, Tooltip, Legend);

const InsightPie = () => {

    const {
        updateTime,
        totalEntries,
        volunteers,
        englishXlation,
        cantoneseXlation,
        do3R5P,
        shuttleBus,
        checkins
    } = useContext(ChartsContext);

    const getCategoryCount = () => {
        switch (selectedCategory) {
            case "Volunteer":
                return volunteers;
            case "English Translation":
                return englishXlation;
            case "Cantonese Translation":
                return cantoneseXlation;
            case "3R5P":
                return do3R5P;
            case "Shuttle Bus":
                return shuttleBus;
            case "Check-ins":
                return checkins;
            default:
                return 0;
        }
    };


    // Chart options
    const options = {
        cutout: '70%', // Adjust this value to control doughnut thickness
    };

    const categoryColors = {
        "Volunteer": 'rgba(54, 162, 235, 0.5)',
        "English Translation": 'rgba(75, 192, 192, 0.5)',
        "Cantonese Translation": 'rgba(255, 159, 64, 0.5)',
        "3R5P": 'rgba(153, 102, 255, 0.5)',
        "Shuttle Bus": 'rgba(255, 99, 132, 0.5)',
        "Check-ins": 'rgba(255, 206, 86, 0.5)'

    };
    const [selectedCategory, setSelectedCategory] = useState("Volunteer");
    const selectedCount = getCategoryCount();
    const nonSelectedCount = totalEntries - selectedCount;
    const selectedColor = categoryColors[selectedCategory];
    const nonSelectedColor = 'rgba(201, 203, 207, 0.5)';

    const data = {
        labels: [selectedCategory + " Guests", 'Non-' + selectedCategory + " Guests"],
        datasets: [
            {
                label: '# of Votes',
                data: [selectedCount, nonSelectedCount],
                backgroundColor: [selectedColor, nonSelectedColor],
                borderColor: [selectedColor.replace('0.5', '1'), nonSelectedColor.replace('0.5', '1')],
                borderWidth: 1,
                hoverOffset: 4
            }
        ]
    };

    const handleSelect = (eventKey, event) => {
        setSelectedCategory(event.target.textContent);
    };


    return (
        <>
            <Card className="card-stats">
                <Card.Header>
                    <Row>
                        <Col>
                            <Card.Title as="h4">來賓比例</Card.Title>
                            <p className="card-category">Doughnut Chart</p>
                        </Col>
                        <Col className="text-right">
                            <Dropdown onSelect={handleSelect}>
                                <Dropdown.Toggle variant="info" id="dropdown-basic">
                                    <span className='font-weight-bold'>{selectedCategory}</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/volunteer">Volunteer</Dropdown.Item>
                                    <Dropdown.Item href="#/english-translation">English Translation</Dropdown.Item>
                                    <Dropdown.Item href="#/cantonese-translation">Cantonese Translation</Dropdown.Item>
                                    <Dropdown.Item href="#/3r5p">3R5P</Dropdown.Item>
                                    <Dropdown.Item href="#/shuttle-bus">Shuttle Bus</Dropdown.Item>
                                    <Dropdown.Item href="#/check-ins">Check-ins</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Doughnut data={data} options={options} />
                </Card.Body>
                <Card.Footer>
                    <hr />
                    <div className="stats">
                        <i className="fas fa-redo mr-1"></i>
                        Updated at <span className="font-weight-bold">{updateTime}</span>
                    </div>
                </Card.Footer>
            </Card>
        </>
    );



}

export default InsightPie;
